/*
 * --------------------------------------------
 * script.js
 * --------------------------------------------
 *
 * Copyright (c) 2013 MyVirtualMission - http://myvirtualmission.com
 *
*/

window.showModalMessage = (title,content) => {
	$('#modal-message').modal({ backdrop: true, keyboard: true, show: false });
	$('#modal-message .modal-header h3').text(title);
	$('#modal-message .modal-body').html(content);
	$('#modal-message').modal('show');
}

$(function() {
	$('.dismiss-alert').on('click', function() {
		$(this).parent().animate({opacity: 0}).slideUp(600);
	});

	$('#enable-streetview').on('click', function(e) {
		switchStreetview();

		e.preventDefault();
	});


	$('#zoom-position').on('click', function(e) {
		if ($(this).hasClass('zoomedin')) {
			resetZoomPosition();
		}
		else {
			zoomPosition();
		}

		e.preventDefault();
	});
	
	if ($('.scroll-more').length > 0) {
		if ($('.scroll-more-inner').height() < 312) {
			$('.scroll-more').removeClass('open').addClass('open');
			$('.scroll-more-trigger').addClass('open').hide();
		}
	}
	$(document).on('click', '.mh-lm-selpopup', function(e) {
		$('ul.mh-lm-dropdown').toggleClass('active');
		e.preventDefault();
	});

	$('.prv-default').on('click', function(e) {
		e.preventDefault();
	});

	$(document).on('click', '.scroll-more-trigger', function(e) {
		$(this).prev('.scroll-more').toggleClass('open');
		$(this).toggleClass('open');

		if ($(this).hasClass('open')) {
			$(this).html('Read less');
		}
		else {
			$(this).html('Read more');
		}

		e.preventDefault();
	});

	$('a[rel="lightbox"]').swipebox();

	$('a[href="/missions/start-mission"]').on('click', function(e) {
		var gaLabel = $(this).attr('data-analyticslabel');
		
		if (typeof gaLabel != 'undefined') {
			ga('send', 'event', 'Start', 'click', gaLabel);
		}
	});

	$('.goal-switch').on('click', function(e) {
		var t = $(this);
		var target = t.attr("data-id");
		$('.goal-switch').removeClass('active');
		if (target == 'average') {
			t.addClass('active');

			$('div#goal-mine').hide();
			$('div#goal-average').show();
		}
		else if (target == 'mine') {
			t.addClass('active');

			$('div#goal-average').hide();
			$('div#goal-mine').show();
		}
		e.preventDefault();
	});

	$('input[name="fundraise_type"]').on('change', function(e) {
		var fundraiseType = $(this).val();
		var missionId = $('input[name="mission_id"]').val();

		$.post("/default/ajax?ajax=get_fundraising_steps",
			{ fundraise_type: fundraiseType, mission_id: missionId },
			function(data) {
				$('div#fundraising-steps').html(data);
				if (jQuery.placeholder) {
			    	jQuery.placeholder.shim();
			    }

			    $( '#charity_description' ).ckeditor(); // Use CKEDITOR.replace() if element is <textarea>.
			});
	});

	 $('#address').on('keypress', function(e) {
		if (e.keyCode == 13) {
			searchLocation($(this).val());
			$(this).val('').blur();

			e.preventDefault();
		}
	});
	$('#address-submit').on('click', function(e) {
		searchLocation($('#address').val());
		
		e.preventDefault();
	});
	$('.unclickable').on('click', function(e) {
		e.preventDefault();
	});

	$('#after-registration-time-zone, #after-registration-distance-unit').select2({
		tags: true,
		dropdownParent: $("#modal-after-registration")
	});

	$('form#after-registration').on('submit', function(e) {
		const timeZoneElement = $('#after-registration-time-zone');
		const distanceUnitElement = $('#after-registration-distance-unit');

		if (timeZoneElement.val() == '') {
			if (!timeZoneElement.hasClass('is-invalid')) {
				timeZoneElement.addClass('is-invalid');
			}
			e.preventDefault();
		}
		else {
			timeZoneElement.removeClass('is-invalid');
		}

		if (distanceUnitElement.val() == '') {
			if (!distanceUnitElement.hasClass('is-invalid')) {
				distanceUnitElement.addClass('is-invalid');
			}

			e.preventDefault();
		}
		else {
			distanceUnitElement.removeClass('is-invalid');
		}
	});

	$('.read-more, .read-less').on('click', function(e) {
		var readMoreId = $(this).attr('data-target');

		var el = $('#'+readMoreId), curHeight = el.height();

		// Replace content
		var readMoreHide = $('#'+readMoreId+' > .hide');
		var readMoreShow = $('#'+readMoreId+' > .show');
		
		readMoreHide.removeClass('hide').addClass('show');
		readMoreShow.removeClass('show').addClass('hide');



		autoHeight = el.css('height', 'auto').height();

		el.height(curHeight).animate({height: autoHeight}, 280);

		//$('#'+readMoreId).css('height','auto');

		e.preventDefault();
	});

	$('.learn-more, .learn-less').on('click', function(e) {
		var learnMoreId = $(this).attr('data-target');
		var el = $('#'+learnMoreId), curHeight = el.height();

		if ($(this).hasClass('learn-more')) {
			$(this).removeClass('learn-more').addClass('learn-less').text('Read less');
			el.removeClass('hide').addClass('show');
		}
		else {
			$(this).removeClass('learn-less').addClass('learn-more').text('Read more');
			el.removeClass('show').addClass('hide');
		}

		/*autoHeight = el.css('height', 'auto').height();
		el.height(curHeight).animate({height: autoHeight}, 280);*/

		e.preventDefault();
	});

	$('.input-wrap input').on('focus', function() {
		$(this).parent().removeClass('focused').addClass('focused');
	});

	$('.input-wrap input').on('blur', function() {
		$(this).parent().removeClass('focused');
	});

	$('label.notification > input[type="checkbox"]').on('change', function() {
		if (this.checked) {
			$(this).parent().removeClass('active').addClass('active');
		}
		else {
			$(this).parent().removeClass('active');
		}
	});

	$('label.notification > input[type="radio"]').on('change', function() {
		if (this.checked) {
			// Remove from all

			$('input[name="'+$(this).attr('name')+'"]').parent().removeClass('active');

			$(this).parent().addClass('active');
		}
		else {
			$(this).parent().removeClass('active');
		}
	});

	$('.mission-boxes .mission-canvas-box-wrap').hover(function() {
		$('img.close-button').stop().fadeTo(200,1);
	}, function() {
		$('img.close-button').stop().fadeTo(200,0.5); 
	});


	$('.autohighlight').on('click', function() {
		this.select();
	});

	$('.quick-search-area input[name="term"]').focus(function() {
		if ($(this).val() == 'Search for something..') {
			$(this).val('').css('color', '#333');
		}
	});

	$('.quick-search-area input[name="term"]').blur(function() {
		if ($(this).val() == '') {
			$(this).val('Search for something..').css('color', '#ccc');
		}
	});

	// Blur on first load
	$('.quick-search-area input[name="term"]').blur();

	/**
	 * Common Functions
	 */

	$('.autosubmit').change(function() {
		this.form.submit();
	});
	$('.autofocus').focus();

	$(document).on('click', 'a.confirmBox', function(e) {
		var answer = confirm($(this).attr('data-content'));

		if (answer) {
			window.location = $(this).attr('href');
		}

		e.preventDefault();
	});

	$('.previous.disabled a, .next.disabled a').click(function(e) {
		e.preventDefault();
	});
	
	$('body').tooltip({
		selector: '[rel=tooltip]'
	});

	$('[rel="popover"]').popover({ placement: 'top', trigger: 'hover', delay: { show: 600, hide: 0 } });

	// $('.progress').each(function() {
	// 	var progressval = 0;
	// 	progressval = $(this).attr('data-progress');
	//
	// 	$(this).progressbar({
	// 		value: progressval
	// 	});
	// });

	$('.upload-submit').on('click', function(e) {
		if ($('.modal input#image').val() != '') {
			$(this).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;UPLOADING..');
		}
	});

	/**
	 * Ajax Functions
	 * from this point onwards..
	 */

	$(document).on('click', '.charity-stats-sort', function(e) {
		var sortBy = $(this).attr('data-sort');

		$('.charity-stats-sort').removeClass('active');
		$('#de-all, #de-mine, #de-statistics').removeClass('active');

		$.post("/default/ajax?ajax=get_charity_events",
	 		{ charity_id: $('#charity_id').val(), event_type: 'distance', filter_type: 'statistics', sort_by: sortBy },
	 		function (data) {
	 			$('.distance-events').html(data);
	 			$('#distance-events').html(data);

	 			$('#de-statistics').addClass('active');
	 		});

		e.preventDefault();
	});

	$(document).on('click', '.group-stats-sort', function(e) {
		var sortBy = $(this).attr('data-sort');

		$('.group-stats-sort').removeClass('active');
		$('#de-all, #de-mine, #de-statistics').removeClass('active');

		$.post("/default/ajax?ajax=get_group_events",
	 		{ group_id: $('#group_id').val(), event_type: 'distance', filter_type: 'statistics', sort_by: sortBy },
	 		function (data) {
	 			$('#group-participants').html(data);

	 			$('#de-statistics').addClass('active');
	 		});

		e.preventDefault();
	});

	$(document).on('click', '.remove-item, #remove-item-app-trigger',function(e) {
		var removeId = $(this).attr('data-id');
		var removeType = '';

		if (removeId.substr(0,7) == 'comment') {
			removeType = 'comment';
			removeId = removeId.substr(8);
		}
		else if (removeId.substr(0,8) == 'activity') {
			removeType = 'activity';
			removeId = removeId.substr(9);
		}

		$.post("/default/ajax?ajax=remove_item",
				{ id: removeId, type: removeType, mission_id: $('#mission_id').val() },
				function(data) {
					var loc = window.location.href,
					index = loc.indexOf('#');

					if (index > 0) {
						window.location = loc.substring(0, index);
					}
					location.reload(true);
				});

		e.preventDefault();
	});

	$(document).on('click', '.remove-item-app',function(e) {
		var removeId = $(this).attr('data-id');
		$('#modal-removeitemapp').modal({ backdrop: true, keyboard: true, show: false });
		$('#remove-item-app-trigger').attr('data-id',removeId);
		$('#modal-removeitemapp').modal('show');
	});


	/* newsfeed remove item */
	$(document).on('click', '.rm-item-app, .rm-item', function(e) {
		var removeId = $(this).attr('data-rmid');
		var removeType = $(this).attr('data-rmtype');
		var missionId = $(this).attr('data-rmmissionid');

		$('#modal-rmitemapp').modal({ backdrop: true, keyboard: true, show: false });
		$('#rm-item-app-trigger').attr('data-rmid',removeId);
		$('#rm-item-app-trigger').attr('data-rmtype',removeType);
		$('#rm-item-app-trigger').attr('data-rmmissionid',missionId);
		$('#modal-rmitemapp').modal('show');

		e.preventDefault();
	});


	$(document).on('click', '#rm-item-app-trigger', function(e) {
		var removeId = $(this).attr('data-rmid');
		var removeType = $(this).attr('data-rmtype');
		var missionId = $(this).attr('data-rmmissionid');

		$.post("/default/ajax?ajax=remove_item",
			{ id: removeId, type: removeType, mission_id: missionId },
			function() {
				// Remove item from the list
				$('.feed-event-delete a[data-rmid="'+removeId+'"]')
					.parent('.feed-event-delete')
					.parent('.feed-event')
					.parent('.feed-event-wrap')
					.remove();
			});

		e.preventDefault();
	});

	$(document).on('click', '.charity-see-more a', function(e) {
	 	var eventType = $(this).attr('href').replace("#",""); // distance, mission, fundraising
	 	var filterType = '';
	 	if (eventType == 'distance') {
	 		if ($('button#de-mine').hasClass('active')) {
	 			filterType = 'mine';
	 		}
	 	}

	 	var seeMoreHandler = $(this);
	 	var seeMoreLimit = '';

	 	$.post("/default/ajax?ajax=get_charity_events",
	 		{ charity_id: $('#charity_id').val(), event_type: eventType, filter_type: filterType, limit: seeMoreLimit },
	 		function (data) {
	 			$('#'+eventType+'-events').html(data);
	 		});
	 	e.preventDefault();
	});

	$('#view-all-followers').on('click', function(e) {
		var missionId = $('#mission_id').val();

		$('#modal-view-all-followers .modal-header h4').html('LOADING');
		$('#modal-view-all-followers .modal-body').html('<p><img src="/skin/default/images/ajax-loader.gif" />&nbsp;&nbsp;&nbsp;&nbsp;Mission followers are being loaded..</p>');
		//$('#modal-view-all-followers').modal('show');

		$.post("/default/ajax?ajax=get_mission_followers",
				{ mission_id: missionId },
				function(data) {
					$('#modal-view-all-followers .modal-header h4').html('MISSION FOLLOWERS');
					$('#modal-view-all-followers .modal-body').html(data);
				});

		e.preventDefault();
	});

	$('#view-all-participants').on('click', function(e) {
		$('#modal-view-all-participants .modal-header h4').html('LOADING');
		$('#modal-view-all-participants .modal-body').html('<p><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Mission participants are being loaded...</p>');
		//$('#modal-view-all-participants').modal('show');

		$.post("/default/ajax?ajax=get_mission_participants",
				{ mission_id: window.missionId },
				function(data) {
					$('#modal-view-all-participants .modal-header h4').html('ON THIS MISSION');
					$('#modal-view-all-participants .modal-body').html(data);
				});

		e.preventDefault();
	});
});